<template>
    <div class="split-view">
        <div class="pdf-viewer">
            <iframe v-if="pdfUrl && !pdfError" :src="pdfUrlWithViewer" type="application/pdf" frameborder="0"
                width="100%" height="100%" @error="handlePdfError"></iframe>
            <div v-if="pdfError || !pdfUrl" class="no-pdf">
                <div class="no-pdf-content">
                    <img src="@/assets/img/chatbot/pdf-icon.svg" alt="PDF icon" />
                    <p>No pudimos encontrar tu PDF</p>
                    <p class="try-again">Intente nuevamente</p>
                </div>
            </div>
        </div>

        <div class="chat-box">
            <div class="chat-header">
                <div class="chat-header-left">
                    <button @click="toggleExpand">
                        <img src="@/assets/img/chatbot/chat/chat-border.svg" alt="message" />
                    </button>
                    <span>Conversación</span>
                </div>
                <button @click="toggleExpand">
                    <img width="18" src="@/assets/img/chatbot/hidden.svg" alt="hidden" />
                </button>
            </div>

            <ChatBox :chatHistory="chatHistory" :newMessage="newMessage" @send="sendMessage"
                @update:newMessage="val => newMessage = val" type="file" @file-uploaded="onFileUploaded"
                :localPdfUrl="localPdfUrl" />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import ChatBox from "@/components/Bot/ChatBox.vue";

export default {
    name: "ChatFile",
    components: { ChatBox },
    data() {
        return {
            pdfError: false,
            thinkingMessageIndex: null
        };
    },
    computed: {
        ...mapState(["chatHistory", "newMessage", "localPdfUrl"]),
        ...mapGetters(["chatType"]),

        pdfUrl() {
            if (this.localPdfUrl) return this.localPdfUrl;

            const fileMessage = this.chatHistory.find(
                msg => msg.type === "file" && msg.name.endsWith(".pdf")
            );
            return fileMessage ? `/pdfs/${encodeURIComponent(fileMessage.name)}` : null;
        },
        pdfUrlWithViewer() {
            if (this.localPdfUrl) return this.localPdfUrl;
            return `https://docs.google.com/gview?url=${encodeURIComponent(window.location.origin + this.pdfUrl)}&embedded=true`;
        }
    },
    methods: {
        ...mapMutations({
            setPdfUrl: "SET_PDF_URL"
        }),
        ...mapActions([
            "addMessage",
            "updateMessage",
            "resetChat"
        ]),

        handlePdfError() {
            this.pdfError = true;
        },
        retryLoading() {
            this.pdfError = false;
        },
        toggleExpand() {
            this.$router.push("/");
        },
        async sendMessage(question) {
            if (!question?.trim()) return;

            await this.addMessage({ from: "me", type: "text", text: question });
            await this.updateMessage("");
            await this.addMessage({ from: "bot", type: "text", text: "Pensando", thinking: true });

            this.thinkingMessageIndex = this.chatHistory.length - 1;

            try {
                const response = await this.$axios.post(
                    "https://api-qa.chelita.com.mx/pdf-agent/ask",
                    {
                        user_id: "123",
                        question
                    },
                    {
                        headers: { "Content-Type": "application/json" }
                    }
                );

                this.$store.commit("ADD_MESSAGE", {
                    from: "bot",
                    type: "html",
                    text: response.data.answer
                });

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1);
            } catch (error) {
                console.error("Error al enviar pregunta:", error);

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1, {
                    from: "bot",
                    type: "text",
                    text: "Ocurrió un error al procesar tu pregunta. Intenta nuevamente."
                });
            }

            this.thinkingMessageIndex = null;
        },
        async onFileUploaded(file) {
            const blobUrl = URL.createObjectURL(file);
            this.setPdfUrl(blobUrl);

            await this.addMessage({
                from: "me",
                type: "file",
                name: file.name,
                text: "Archivo cargado correctamente.",
                icon: require("@/assets/img/chatbot/pdf-icon.svg")
            });

            await this.addMessage({ from: "bot", type: "text", text: "Pensando", thinking: true });

            this.thinkingMessageIndex = this.chatHistory.length - 1;

            try {
                const formData = new FormData();
                formData.append("user_id", "123");
                formData.append("file", file);

                await this.$axios.post(
                    "https://api-qa.chelita.com.mx/pdf-agent/upload-pdf",
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1, {
                    from: "bot",
                    type: "text",
                    text: "El archivo fue subido correctamente al servidor."
                });
            } catch (error) {
                console.error("Error al subir el archivo:", error);

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1, {
                    from: "bot",
                    type: "text",
                    text: "Hubo un error al subir el archivo. Intenta nuevamente."
                });
            }

            this.thinkingMessageIndex = null;
        }
    },
    mounted() {
        if (this.chatHistory.length === 0) {
            this.addMessage({
                from: "bot",
                type: "text",
                text: "Necesitas cargar un archivo PDF para empezar a interactuar.",
            });
        }
    }
};
</script>



<style scoped>
.split-view {
    display: flex;
    height: 100vh;
    background-color: #17181B;
    overflow: hidden;
}

.pdf-viewer {
    width: 40vw;
    height: 100%;
    background-color: #17181B;
    border-right: 1px solid #2a2b2e;
    overflow: hidden;
    position: relative;
}

.chat-box {
    width: 40vw;
    display: flex;
    flex-direction: column;
    background-color: #061821;
    height: 100%;
    overflow: hidden;
}

.chat-header {
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    padding: 1rem;
    background-color: #17181B;
    border-bottom: 1px solid #2a2b2e;
}

.chat-header-left {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    gap: 10px;
}

.chat-header button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.chat-header span {
    color: #ffffff;
    font-weight: bold;
}

.no-pdf {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #ffffff;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #17181B;
}

.no-pdf-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 2rem;
    max-width: 300px;
}

.no-pdf-content img {
    width: 60px;
    height: 60px;
    filter: brightness(0) invert(1);
    opacity: 0.7;
}

.no-pdf-content p {
    margin: 0;
    font-size: 1.1rem;
}

.try-again {
    color: #80868B;
    font-size: 0.9rem;
}

.retry-btn {
    background-color: #2c6b94;
    border: none;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 1rem;
    font-size: 0.9rem;
}

.retry-btn:hover {
    background-color: #3a7ca5;
}


@media (max-width: 768px) {
    .chat-header {
        background-color: #061821;
    }

    .split-view {
        flex-direction: column;
        height: 100dvh;
        overflow: hidden;
    }

    .pdf-viewer {
        display: none;
    }

    .chat-box {
        width: 100vw;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
}
</style>
